import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../../assets/images/login_bg.jpg'
import _imports_1 from '../../../assets/images/logo.png'


const _hoisted_1 = { class: "set-password-container" }
const _hoisted_2 = { class: "login-form" }
const _hoisted_3 = {
  key: 0,
  class: "status-panel"
}
const _hoisted_4 = {
  key: 1,
  class: "status-panel"
}
const _hoisted_5 = { class: "status-icon" }
const _hoisted_6 = { class: "status-desc" }
const _hoisted_7 = {
  key: 2,
  class: "status-panel"
}
const _hoisted_8 = { class: "status-icon" }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "user-greeting" }
const _hoisted_11 = { class: "user-highlight" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircleClose = _resolveComponent("CircleClose")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CircleCheck = _resolveComponent("CircleCheck")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("img", {
      src: _imports_0,
      alt: "",
      class: "image"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "title-container" }, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "",
            style: {"width":"100%"}
          })
        ]),
        _createElementVNode("h3", { class: "title" }, "新用户激活 / 密码设置")
      ], -1)),
      (_ctx.validating)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("p", {
              class: "status-desc",
              style: {"padding":"20px 0"}
            }, "正在验证安全链接，请稍候...", -1)
          ]))]))
        : (_ctx.tokenInvalid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_CircleClose, { style: {"width":"48px","height":"48px","color":"#f56c6c"} })
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "status-title" }, "链接已失效或过期", -1)),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.errorMsg || '此安全链接已失效或超过30分钟有效期。请返回登录页重新申请。'), 1),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"width":"100%","margin-top":"22px"},
                onClick: _ctx.goToLogin
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("返回登录页", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : (_ctx.isSuccess)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_CircleCheck, { style: {"width":"48px","height":"48px","color":"#67c23a"} })
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "status-title" }, "密码设置成功！", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "status-desc" }, "您的新密码已设置，账号已激活。请使用工号和新密码登录系统。", -1)),
                _createVNode(_component_el_button, {
                  type: "primary",
                  style: {"width":"100%","margin-top":"22px"},
                  onClick: _ctx.goToLogin
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("立即去登录", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_ctx.tokenValid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[9] || (_cache[9] = _createTextVNode(" 您好，", -1)),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.userDetail.name || _ctx.userDetail.username), 1),
                    _createTextVNode("（工号：" + _toDisplayString(_ctx.userDetail.username) + "），请设置系统登录密码： ", 1)
                  ]),
                  _createVNode(_component_el_form, {
                    ref: "pwdFormRef",
                    model: _ctx.pwdForm,
                    rules: _ctx.pwdRules,
                    autocomplete: "off",
                    "label-position": "left"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "newPassword" }, {
                        default: _withCtx(() => [
                          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "svg-container" }, [
                            _createElementVNode("i", { class: "iconfont icon-mima" })
                          ], -1)),
                          _createVNode(_component_el_input, {
                            ref: "newPasswordRef",
                            modelValue: _ctx.pwdForm.newPassword,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pwdForm.newPassword) = $event)),
                            type: "password",
                            "show-password": "",
                            placeholder: "请输入新密码",
                            clearable: "",
                            autocomplete: "new-password"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { prop: "confirmNewPassword" }, {
                        default: _withCtx(() => [
                          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "svg-container" }, [
                            _createElementVNode("i", { class: "iconfont icon-mima" })
                          ], -1)),
                          _createVNode(_component_el_input, {
                            ref: "confirmNewPasswordRef",
                            modelValue: _ctx.pwdForm.confirmNewPassword,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pwdForm.confirmNewPassword) = $event)),
                            type: "password",
                            "show-password": "",
                            placeholder: "请再次确认新密码",
                            clearable: "",
                            autocomplete: "new-password",
                            onKeyup: _withKeys(_ctx.handleSubmit, ["enter"])
                          }, null, 8, ["modelValue", "onKeyup"])
                        ]),
                        _: 1
                      }),
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "pwd-tip" }, [
                        _createElementVNode("div", { class: "tip-title" }, "密码安全要求："),
                        _createElementVNode("div", { class: "tip-item" }, "• 长度为 10 ~ 100 位，不能包含空格"),
                        _createElementVNode("div", { class: "tip-item" }, "• 必须同时包含英文字母、数字和特殊字符")
                      ], -1)),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        style: {"width":"100%"},
                        loading: _ctx.submitting,
                        onClick: _withModifiers(_ctx.handleSubmit, ["prevent"])
                      }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode(" 完成设置并激活 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["loading", "onClick"]),
                      _createElementVNode("p", {
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToLogin && _ctx.goToLogin(...args))),
                        style: {"text-align":"center","color":"#fff","margin-top":"15px"},
                        class: "cursor"
                      }, "返回登录")
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]))
              : _createCommentVNode("", true)
    ])
  ]))
}